<template>
	<ResumeAnalysisModal v-if="step === 'analysis'" />
	<WeakResumeModal v-else-if="step === 'weak-resume'" />
	<QualificationModal v-else-if="step === 'qualification'" />
	<PreferencesModal v-else-if="step === 'preferences'" />
</template>

<script setup>
import { storeToRefs } from 'pinia';

import ResumeAnalysisModal from './resume-analysis-modal.vue';
import WeakResumeModal from './weak-resume-modal.vue';
import QualificationModal from './qualification-modal.vue';
import PreferencesModal from './preferences-modal.vue';
import { useExistingUserAutoApplyStore } from '../../store/existing-user-auto-apply.store';

/**
 * Renders the existing-user AutoApply flow's current modal, whichever page the user is on.
 * EN-776 adds its promo and Resume Gate steps here alongside EN-777's.
 */
const { step } = storeToRefs(useExistingUserAutoApplyStore());
</script>
